import { render, staticRenderFns } from "./TestDetailsMobile.vue?vue&type=template&id=12a18d92"
import script from "./TestDetailsMobile.vue?vue&type=script&lang=js"
export * from "./TestDetailsMobile.vue?vue&type=script&lang=js"
import style0 from "./TestDetailsMobile.vue?vue&type=style&index=0&id=12a18d92&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports